import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Indicator from './indicator';
import { indicatorWrapperStaticStyle } from './styles';
const indicatorsCount = {
    advanced: 3,
    beginner: 1,
    intermediate: 2,
};
function LevelIndicators({ level, size, variant }) {
    return (_jsx("div", Object.assign({ css: indicatorWrapperStaticStyle }, { children: Array.from({ length: indicatorsCount[level] }, (_, index) => {
            return _jsx(Indicator, Object.assign({}, { size, variant }), `indicator-${index}`);
        }) })));
}
export default LevelIndicators;
